import angular from 'angular';
import tableComponentComponent from './tableComponent.component';

let tableComponentModule = angular.module('tableComponent', []).component('tableComponent', tableComponentComponent);

export default tableComponentModule;



// WEBPACK FOOTER //
// ./app/components/tableComponent/tableComponent.js